import { useRef } from 'react'
import Button from 'components/Button'
import { FormField } from 'components/Inputs'
import useSignInForm from './useSignInForm'
import AlertGroup from 'components/AlertGroup'
import { useTrackPageVisit } from 'lib/contexts/Mixpanel'
import Anchor from 'components/Anchor'
import { Link, useLocation } from 'react-router-dom'
import alertMessages from 'lib/enums/alertMessages'
import ThirdParty from './ThirdParty'
import Layout from 'layouts'

const SignIn = () => {
  useTrackPageVisit('SignIn')

  return (
    <Layout>
      <div className='max-w-lg w-full mx-auto px-4 pt-12 pb-8 space-y-8'>
        <h2 className='font-semibold text-xl'>Sign in to your account</h2>

        <ThirdParty />
        <div>
          <SignInForm />
          <div className='text-sm mt-6'>
            Don't have an account?{' '}
            <Anchor
              className='text-sm text-opacity-70 text-brand-900'
              component={Link}
              to='/signup'>
              Sign up
            </Anchor>
          </div>
        </div>
      </div>
    </Layout>
  )
}

const SignInForm = () => {
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    values,
    errors,
    touched,
    isSubmitting,
    status,
  } = useSignInForm()
  const location = useLocation<{ resetPassword?: string }>()

  const stateRef = useRef(location.state?.resetPassword)

  const alert =
    status?.error?.networkError?.result?.errors[0]?.message || stateRef.current

  return (
    <form onSubmit={handleSubmit}>
      {alert ? (
        <AlertGroup className='mb-5' alert={alertMessages[alert]} />
      ) : null}
      <FormField
        id='email'
        name='email'
        label='Email Address'
        placeholder='your@email.com'
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.email}
        error={touched.email ? errors.email : undefined}
      />
      <div className='relative pb-4'>
        <FormField
          id='password'
          name='password'
          label='Password'
          placeholder='••••••••'
          type='password'
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.password}
          error={touched.password ? errors.password : undefined}
          className='mt-4.5'
        />
        <Anchor
          component={Link}
          to='/reset-password'
          // NOTE: this is a hack until we fix FormField
          // error placement
          className='text-xs absolute top-[88px] right-0'>
          Forgot Password?
        </Anchor>
      </div>
      <Button
        type='submit'
        className='w-full mt-10'
        disabled={isSubmitting}
        loading={isSubmitting}
        hasIcon>
        <span>Sign in</span>
      </Button>
    </form>
  )
}

export default SignIn
